import * as d3 from 'd3'

const maxColLengthDesktop = 5
const maxColLengthMobile = 4
const mobileWidth = 375
const mobileHeight = 845
export const getFreshNodes = (
  currentScene: Scene,
  width: number,
  height: number,
  isFirstTime?: boolean
) => {
  return currentScene.categories
    .map((category, catIndex) => {
      return d3.range(category.value).map(function (d, personIndex) {
        if (currentScene.svgPositions && currentScene.svgPositionsDimensions && isFirstTime) {
          console.log("🆕 getFreshNodes")
          return {
            radius: category.radius ?? 5,
            category: category.title,
            catIndex: catIndex,
            x:
              currentScene.svgPositions[personIndex].cx +
              width / 2 -
              currentScene.svgPositionsDimensions.width / 2,
            y:
              currentScene.svgPositions[personIndex].cy +
              height / 2 -
              currentScene.svgPositionsDimensions.height / 2,
          }
        }
        return {
          radius: category.radius ?? 5,
          category: category.title,
          catIndex: catIndex,
        }
      })
    })
    .flat()
}
export const initializeSimulation = (
  simulation: d3.Simulation<any, undefined>,
  nodes: {
    radius: number
    category: string
    color: string
    catIndex: number
  }[],
  currentScene: Scene,
  width: number,
  height: number,
  personsSvgGroup: SVGGElement,
  labelsSvgGroup: SVGGElement
) => {
  console.log('🆕 initializeSimulation')
  simulation.restart()
  const ticked = (nodesNew: any) => {
    var u = d3
      .select(personsSvgGroup)
      .selectAll('circle')
      .data(nodesNew)
      .join('circle')
      .attr('r', function (d: any) {
        return d.radius
      })
      // .style('fill', function (d: any) {
      //   return d.color
      // })
      .attr('cx', function (d: any) {
        return d.x
      })
      .attr('cy', function (d: any) {
        return d.y
      })
      .attr('id', (d: any) => 'index' + d.index)
  }
  applyForces(simulation, nodes, currentScene, width, height)
    .on('tick', () => ticked(nodes))
    .on('end', function () {
      console.log('end')
    })
  appendTextLabelValue(labelsSvgGroup, currentScene, width, height)
  appendTextLabels(labelsSvgGroup, currentScene, width, height)
}

export const updateSimulation = (
  simulation: d3.Simulation<any, undefined>,
  nodes: {
    radius: number
    category: string
    color: string
    catIndex: number
    x?: number
    y?: number
    vx?: number
    vy?: number
  }[],
  currentScene: Scene,
  width: number,
  height: number,
  personsSvgGroup: SVGGElement,
  labelsSvgGroup: SVGGElement
) => {
  personsSvgGroup.childElementCount < 1 &&
    initializeSimulation(
      simulation,
      nodes,
      currentScene,
      width,
      height,
      personsSvgGroup,
      labelsSvgGroup
    )
  console.log('⬆️ updateSimulation', currentScene.title, { width })
  // select nodes
  d3.select(personsSvgGroup)
    .selectChildren()
    .data(nodes)
    .attr('class', function (d: any) {
      const numberOfGrayedOutPersons =
        currentScene.categories[d.catIndex].grayedOut
      if (numberOfGrayedOutPersons) {
        const sumOfPreviousCategories = currentScene.categories
          .slice(0, d.catIndex)
          .reduce((previousVal, currentVal, curretIndex): number => {
            return previousVal + currentVal.value
          }, 0)
        console.log(sumOfPreviousCategories)

        if (d.index < sumOfPreviousCategories + numberOfGrayedOutPersons) {
          return 'grayedOut'
        }
      }
      return ''
    })

  applyForces(simulation, nodes, currentScene, width, height)
    .on('tick', function () {
      d3.select(personsSvgGroup)
        .selectAll('circle')
        .data([...nodes])
        .attr('cx', function (d: any) {
          return d.x
        })
        .attr('cy', function (d: any) {
          return d.y
        })
    })
    .alpha(0.8)
    .restart()
  appendTextLabelValue(labelsSvgGroup, currentScene, width, height)
  appendTextLabels(labelsSvgGroup, currentScene, width, height)
}
const positionColumnsCX = (
  d: any,
  index: number,
  svgWidth: number,
  svgHeight: number,
  scene: Scene
) => {
  const isMobile = svgWidth < mobileWidth || svgHeight < mobileHeight
  const maxColLength = isMobile ? maxColLengthMobile : maxColLengthDesktop
  const numberOfColums = Math.ceil(scene.categories.length / maxColLength)
  const column = Math.floor(index / maxColLength) + 1
  // const biggestGroup = Math.max(...scene.categories.map((cat) => cat.value))

  // if width of the chart is bigger than 664px use 2 / 3 is the width of the chart in relation to the svg and subtract the padding and the biggest group
  const scaleFactor = 1
  // const padding = Math.max(20, biggestGroup * 2)
  const widthOfChart = svgWidth * scaleFactor

  const stretchFactor = (numberOfColums + 1) / 2 - column
  return (
    column * (widthOfChart / (numberOfColums + 1)) -
    stretchFactor * (100 - numberOfColums * 30)
  )
}

const positionColumnsCY = (
  d: any,
  index: number,
  svgWidth: number,
  svgHeight: number,
  scene: Scene
) => {
  const isMobile = svgWidth < mobileWidth || svgHeight < mobileHeight
  const maxColLength = isMobile ? maxColLengthMobile : maxColLengthDesktop
  const hasMultipleColumns = Math.ceil(scene.categories.length / maxColLength)
  const shift = scene.categories.length > 2 ? 100 : 0
  if (hasMultipleColumns === 1) {
    // only one column
    return (
      ((svgHeight - shift) / (scene.categories.length + 1)) * (index + 1) +
      shift / 2
    )
  }
  return (
    ((svgHeight - shift) / (maxColLength + 1)) * ((index % maxColLength) + 1) +
    shift / 2
  )
}

const appendTextLabelValue = (
  svgGroupToAppendTo: SVGGElement,
  currentScene: Scene,
  width: number,
  height: number
) => {
  d3.select(svgGroupToAppendTo).selectChildren().remove()
  d3.select(svgGroupToAppendTo)
    .selectAll('text')
    .data(currentScene.categories)
    .join('foreignObject')
    .html(function (d) {
      if (d.value <= 7 && d.value !== 0) return ''
      return (
        `<div class='labelWrapper'>` +
        // `<div>${d.title}</div>` +
        `<div style="font-size:${(d.value - 50) / 100 + 1}em">${
          d.value
        }</div>` +
        `</div>`
      )
    })
    .style('height', '100%')
    .attr('class', 'textLabel value')
    .attr('x', function (d: any, index) {
      return positionColumnsCX(d, index, width, height, currentScene) - 80
    })
    .attr('y', function (d: any, index) {
      return positionColumnsCY(d, index, width, height, currentScene) //+ calculateRadiusOfLargerCircleTwo(d.value, 5)
    })
}

const appendTextLabels = (
  svgGroupToAppendTo: SVGGElement,
  currentScene: Scene,
  width: number,
  height: number
) => {
  // d3.select(svgGroupToAppendTo).selectChildren().remove()
  d3.select(svgGroupToAppendTo)
    .selectAll('text')
    .data(currentScene.categories)
    .join('foreignObject')
    .html(function (d) {
      return (
        `<div class='labelWrapper'>` +
        `<div>${d.title}</div>` +
        // `<div>${d.value}</div>` +
        `</div>`
      )
    })
    .style('height', '100%')
    .attr('class', 'textLabel text')
    .attr('x', function (d: any, index) {
      return positionColumnsCX(d, index, width, height, currentScene) - 80
    })
    .attr('y', function (d: any, index) {
      return (
        positionColumnsCY(d, index, width, height, currentScene) -
        calculateRadiusOfLargerCircleTwo(d.value, 5)
      )
    })
}
export const setSvgPositions = (
  svgPositions: { cx: number; cy: number; radius?: number }[],
  width: number,
  height: number,
  svgGroupToAppendTo: SVGGElement
) => {
  d3.select(svgGroupToAppendTo)
    .selectAll('circle')
    .data(svgPositions)
    .join('circle')
    .attr('cx', function (d: any) {
      return d.cx + width / 2
    })
    .attr('cy', function (d: any) {
      return d.cy + height / 2
    })
    .attr('r', (d) => d.radius ?? 5)
    .attr('fill', 'red')
}
// function calculateRadiusOfLargerCircle(numSmallerCircles: number, smallerCircleRadius: number) {
//   const pi = Math.PI;
//   const angleBetweenCenters = 2 * pi / numSmallerCircles;
//   const halfDistanceBetweenCenters = smallerCircleRadius / Math.tan(angleBetweenCenters / 2);
//   const radiusOfLargerCircle = halfDistanceBetweenCenters + smallerCircleRadius;
//   return radiusOfLargerCircle;
// }

function calculateRadiusOfLargerCircleTwo(
  numSmallerCircles: number,
  smallerCircleRadius: number
) {
  /* je kleiner die Anzahl Kreise desto grösser die holyNumber */
  const holyNumber = (100 - numSmallerCircles) / 120 + 1.9
  const countCircleRows = Math.ceil((numSmallerCircles - 1) / 17 + holyNumber)
  const radiusOfLargerCircle =
    countCircleRows * 2 * smallerCircleRadius + smallerCircleRadius
  return radiusOfLargerCircle
}

const applyForces = (
  simulation: d3.Simulation<any, undefined>,
  nodes: {
    radius: number
    category: string
    color: string
    catIndex: number
    x?: number
    y?: number
    vx?: number
    vy?: number
  }[],
  currentScene: Scene,
  width: number,
  height: number
) => {
  return simulation
    .nodes(nodes)
    .force(
      'x',
      d3.forceX().x(function (d: any) {
        if (
          currentScene.svgPositions &&
          currentScene.svgPositionsDimensions?.width
        ) {
          return (
            currentScene.svgPositions[d.index].cx +
            width / 2 -
            currentScene.svgPositionsDimensions.width / 2
          )
        }
        return positionColumnsCX(d, d.catIndex, width, height, currentScene)
      })
    )
    .force(
      'y',
      d3.forceY().y(function (d: any) {
        if (
          currentScene.svgPositions &&
          currentScene.svgPositionsDimensions?.height
        ) {
          return (
            currentScene.svgPositions[d.index].cy +
            height / 2 -
            currentScene.svgPositionsDimensions.height / 2
          )
        }
        return positionColumnsCY(d, d.catIndex, width, height, currentScene)
      })
    )
    .force(
      'collision',
      d3.forceCollide().radius(function (d: any) {
        if (currentScene.svgPositions) {
          return 0
        }
        return d.radius
      })
    )
}
